import Alpine from "alpinejs";
import locationInformation from "./locationInformation";
import searchSite from "./siteSearch";
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);

const components = {
    locationInformation,
    searchSite,
};

Object.entries(components).forEach(([name, module]) => {
    Alpine.data(name, module);
});

console.log("start");
window.Alpine = Alpine;
Alpine.start();
